































/** @format */

import { Vue, Component, Mixins } from 'vue-property-decorator';
import * as routeNames from '../router-names';
import GoBackWithCloseTab from '@root/common/mixins/go-back-with-close-tab';
import moment from 'moment';
import { queryParkingSpaceDetail } from '../../../api/parking-space-list';
import { PARKING_SPACE_LIST } from '../router-names';
import { Mutation } from 'vuex-class';
import { CLOSE_CURRENT_TAB } from '@/store/mutation-types';
import {
  useTypeMap,
  categoryMap,
  useStatusMap,
  spaceTypeMap,
  statusMap,
  lockedMap
} from '../../../types/parking-space-management/dictionaries';

@Component
export default class EnergyRecordDetail extends Mixins(GoBackWithCloseTab) {
  path = '/smart-parking/parking-space-management/parking-space-list/';

  private navs = [
    {
      label: '车位资源管理',
      location: {
        name: routeNames.PARKING_SPACE_LIST
      }
    },
    {
      label: '车位资源管理详情'
    }
  ];

  private detailModel = {};

  private parkingDetail = [
    {
      prop: 'parkName',
      label: '所属车场'
    },
    {
      prop: 'category',
      label: '车位类别'
    },
    {
      prop: 'useArea',
      label: '车位面积'
    },
    {
      prop: 'areaName',
      label: '所在区域'
    },
    {
      prop: 'useType',
      label: '车位用途'
    },
    {
      prop: 'spaceType',
      label: '车位类型'
    },
    {
      prop: 'status',
      label: '车位状态'
    },
    {
      prop: 'number',
      label: '泊车数量'
    }
    // {
    //   prop: 'isLock',
    //   label: '是否为地锁车位'
    // },
    // {
    //   prop: 'lockCode',
    //   label: '车位锁编号'
    // },
    // {
    //   prop: 'lockBinding',
    //   label: '车位锁绑定码'
    // }
  ];
  private authDetail = [
    {
      prop: 'useStatus',
      label: '使用状态'
    },
    {
      prop: 'name',
      label: '姓名'
    },
    {
      prop: 'phoneNumber',
      label: '联系电话'
    },
    // {
    //   prop: 'contractPeriod',
    //   label: '合同期限',
    // },
    {
      prop: 'authorizationPeriod',
      label: '授权期限'
    },
    {
      prop: 'roomNumber',
      label: '房号/住址'
    }
  ];
  defaultCustomRender(text: string) {
    return text || '-';
  }
  private tableColums = [
    // {
    //   title: '姓名',
    //   dataIndex: 'name',
    //   customRender: this.defaultCustomRender,
    // },
    // {
    //   title: '人员ID',
    //   dataIndex: 'userId',
    //   customRender: this.defaultCustomRender,
    // },
    // {
    //   title: '房号',
    //   dataIndex: 'roomNumber',
    //   customRender: this.defaultCustomRender,
    // },
    // {
    //   title: '联系电话',
    //   dataIndex: 'phoneNumber',
    //   customRender: this.defaultCustomRender,
    // },
    {
      title: '业务类型',
      dataIndex: 'operateType'
    },
    {
      title: '办理时间',
      dataIndex: 'operateTime'
    },
    {
      title: '操作人',
      dataIndex: 'operater'
    }
  ];
  async created() {
    const id = this.$route.params.id;
    try {
      const { status, code, msg, data } = await queryParkingSpaceDetail({
        spaceId: id
      });
      this.detailModel = {
        ...data,
        status: statusMap[data.status],
        useStatus: useStatusMap[data.useStatus],
        useArea: data.useArea ? data.useArea : '-' + '平方米',
        isLock: lockedMap[data.isLock]
        // useType: useTypeMap[data.useType],
        // spaceType: spaceTypeMap[data.spaceType],
        // category: categoryMap[data.category]
      };
    } catch (error) {
      this.$message.error(error.msg);
      console.log('queryParkingSpaceDetail error', JSON.stringify(error));
    }
  }
  @Mutation(`pageTabs/${CLOSE_CURRENT_TAB}`)
  closeCurrentTab!: Function;
  goBack() {
    this.closeCurrentTab();
    // 页面返回
    this.$router.replace({
      name: PARKING_SPACE_LIST
    });
  }
}
